import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChevronCollapseIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chevron-collapse"><g id="Icon"><path fillRule="evenodd" clipRule="evenodd" d="M2.40002 12C2.40002 11.5029 2.80297 11.1 3.30002 11.1H20.7C21.1971 11.1 21.6 11.5029 21.6 12C21.6 12.4971 21.1971 12.9 20.7 12.9H3.30002C2.80297 12.9 2.40002 12.4971 2.40002 12Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M11.3636 7.73635C11.7151 8.08782 12.2849 8.08782 12.6364 7.73635L16.1364 4.23635C16.4878 3.88488 16.4878 3.31503 16.1364 2.96356C15.7849 2.61208 15.2151 2.61208 14.8636 2.96356L12 5.82716L9.13637 2.96356C8.7849 2.61208 8.21505 2.61208 7.86358 2.96356C7.51211 3.31503 7.51211 3.88488 7.86358 4.23635L11.3636 7.73635Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M7.86358 21.1363C8.21505 21.4878 8.7849 21.4878 9.13637 21.1363L12 18.2727L14.8636 21.1363C15.2151 21.4878 15.7849 21.4878 16.1364 21.1363C16.4878 20.7849 16.4878 20.215 16.1364 19.8636L12.6364 16.3636C12.2849 16.0121 11.7151 16.0121 11.3636 16.3636L7.86358 19.8636C7.51211 20.215 7.51211 20.7849 7.86358 21.1363Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChevronCollapseIcon;